/**
 * Cookieless landing attribution (`dat`) handed over from denker.ai.
 *
 * Closed labels only (UTM values, referring domain, landing path) and no
 * visitor id, so it needs no consent. Kept in memory for this page load and
 * forwarded at sign-up; the backend (apps/accounts/attribution_token.py)
 * re-validates every field and ignores anything malformed.
 */
const PARAM = "dat";
const MAX_LENGTH = 1024;
let pending: string | undefined;

export function clearAttributionToken(): void {
  pending = undefined;
}

/** Strip the carrier from the address bar and keep a single well-formed token. */
export function captureAttributionToken(href = window.location.href): void {
  try {
    const url = new URL(href);
    const values = url.searchParams.getAll(PARAM);
    if (!values.length) return;
    url.searchParams.delete(PARAM);
    window.history.replaceState(
      window.history.state,
      "",
      `${url.pathname}${url.search}${url.hash}`,
    );
    const raw = values.length === 1 ? values[0] : "";
    const data: unknown =
      raw && raw.length <= MAX_LENGTH ? JSON.parse(raw) : null;
    pending =
      data && typeof data === "object" && (data as { v?: unknown }).v === 1
        ? raw
        : undefined;
  } catch {
    // Optional metadata must never prevent sign-up.
    clearAttributionToken();
  }
}

export function attributionTokenFields(): { attribution_token?: string } {
  return pending ? { attribution_token: pending } : {};
}

export function attributionTokenQuery(): [string, string][] {
  return pending ? [[PARAM, pending]] : [];
}
